angular.module('leanlaw').directive('llProductNotice', () => ({
  restrict: 'E',
  replace: true,
  scope: {
    label: '@',
    small: '=',
    trial: '=',
    product: '@'
  },
  template: require("./views/llProductNotice.html"),
  controller: 'UpgradeMessageController'
})).controller('UpgradeMessageController', ['$scope', 'userService', async ($scope, userService) => {
  $scope.label = $scope.label || "This feature is";
  $scope.me = await userService.me();
  $scope.admin = $scope.me.access.setup;
  $scope.show = !$scope.me.features[$scope.product];
  $scope.trial = $scope.trial && $scope.me.company.products.trial;
}]);